@if (conditionalIncentiveFeatureFlagEnabled) {
  <div>
    @if (isLoading) {
      <p-progressSpinner></p-progressSpinner>
    }
    <p-divider></p-divider>
    <h3>Conditional Incentives Configurator</h3>
    <tr class="p-grid form-row" title="Conditional Incentives">
      <td class="p-col-1">
        <button pButton type="button" class="p-button-success" label="Add" (click)="addIncentive()"></button>
      </td>
    </tr>
    @if (isFormLoaded) {
      <div [formGroup]="incentiveForm">
        <div formArrayName="incentives">
          <tr class="p-grid p-justify-even form-row">
            <th class="p-col-3">Group Affiliation</th>
            <th class="p-col-3">Previous Ownership</th>
            <th class="p-col-3">Incentive Application</th>
            <th class="p-col-1"></th>
          </tr>
          @for (incentive of incentives.controls; track incentive; let idx = $index) {
            <div class="p-grid p-justify-center p-align-center p-justify-even form-row"
              [formGroupName]="idx">
              <td class="p-col-3 position-relative">
                <p-select [options]="groupAffiliations"
                  formControlName="groupAffiliation"
                  placeholder="Select Group Affiliation"
                  filter="true"
                optionLabel="name"></p-select>
                @if (incentive.get('groupAffiliation').invalid) {
                  <div>
                    <small class="invalid-text">Group Affiliation is required.</small>
                  </div>
                }
              </td>
              <td class="p-col-3 position-relative">
                <p-select [options]="previousOwnerships"
                  formControlName="previousOwnership"
                  filter="true"
                  placeholder="Select Previous Ownership"
                optionLabel="name"></p-select>
                @if (incentive.get('previousOwnership').invalid) {
                  <div>
                    <small class="invalid-text">Previous Ownership is required.</small>
                  </div>
                }
                @if (incentive.errors?.duplicateCombination) {
                  <div>
                    <small class="invalid-text">This combination already exists.</small>
                  </div>
                }
              </td>
              <td class="p-col-3 position-relative">
                <p-select [options]="applicationValues"
                  formControlName="applicationValue"
                placeholder="Select Incentive Application"></p-select>
                @if (incentive.get('applicationValue').invalid) {
                  <div>
                    <small class="invalid-text">Application Type is required.</small>
                  </div>
                }
              </td>
              <td class="p-col-1 position-relative">
                <button pButton type="button" class="p-button-danger p-button-icon" (click)="removeIncentive(idx)">
                  <i class="pi pi-trash"></i>
                </button>
              </td>
            </div>
          }
          @if (incentives.controls.length === 0) {
            <tr class="p-grid p-justify-even">
              <div class="label-below no-incentives">No Incentive configurations created yet.</div>
            </tr>
          }
        </div>
      </div>
    }
  </div>
}
